import React, { useState } from 'react';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { IconButton, useMediaQuery } from '@mui/material';

import TagList from '../../../components/tag-list/TagList';

import scss from './TagsOutput.module.scss';
import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';

function TagsOutput({ slide }) {
  const { tags } = slide || {};

  const [isOpen, setIsOpen] = useState(false);

  const isMobile = useMediaQuery('(max-width: 768px)');
  const isTagsVisible = !isMobile || isOpen;

  const handleToggleTags = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div className={scss.wrapper}>
      {isMobile && (
        <CommonButton styleColor={BUTTON_STYLES.PRIMARY} onClick={handleToggleTags} className={scss.toggleButton}>
          <LocalOfferOutlinedIcon />
        </CommonButton>
      )}
      {isTagsVisible && <TagList tags={tags} />}
    </div>
  );
}

export default TagsOutput;
